import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqs = [
  {
    q: '触手漫画网是否需要注册才能阅读？',
    a: '不需要！触手漫画网所有内容完全免费，无需注册即可直接在线阅读。打开网站就能畅读你喜爱的触手漫画，没有任何门槛。',
  },
  {
    q: '触手漫画的更新频率是怎样的？',
    a: '触手漫画网每日更新，编辑团队实时追踪各作品的连载进度，确保读者第一时间看到最新的触手漫画章节。热门作品通常每日都有更新。',
  },
  {
    q: '支持哪些设备阅读触手漫画？',
    a: '触手漫画网全面适配 PC、平板和手机端，采用响应式设计。特别优化了下拉式阅读体验，在手机上也能流畅浏览触手漫画的全部内容。',
  },
  {
    q: '可以下载触手漫画离线阅读吗？',
    a: '触手漫画网目前为在线阅读平台，暂不提供下载功能。但我们优化了页面加载速度，即使在移动网络环境下也能快速加载漫画内容。',
  },
  {
    q: '如何向触手漫画网推荐作品或提供反馈？',
    a: '欢迎通过联系模块向我们推荐优质的触手题材漫画或提供使用反馈。编辑团队会认真对待每一条建议，不断优化触手漫画网的阅读体验。',
  },
];

export default function FAQSection() {
  const { ref: titleRef, visible: titleVisible } = useScrollReveal(0.12);

  return (
    <section id="faq" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div ref={titleRef} className={`text-center mb-12 ${titleVisible ? 'animate-fade-in-up' : 'animate-initial-hidden'}`}>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100/60 border border-secondary-200/50 mb-4">
            <i className="ri-question-answer-line text-secondary-600 text-xs w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-secondary-700 whitespace-nowrap">常见疑问解答</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问答
          </h2>
          <div className="w-16 h-0.5 bg-primary-500 mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-600">
            关于触手漫画网的常见问题，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <FaqItem key={idx} faq={faq} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FaqItem({ faq, idx }: { faq: typeof faqs[0]; idx: number }) {
  const { ref, visible } = useScrollReveal(0.06);

  return (
    <div
      ref={ref}
      className={`bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-colors ${
        visible ? `animate-fade-in-up animate-stagger-${idx + 1}` : 'animate-initial-hidden'
      }`}
    >
      <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
        <span className="text-primary-500 font-heading mr-2">Q{idx + 1}.</span>
        {faq.q}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
    </div>
  );
}